module.exports = __webpack_public_path__ + "static/media/img-procedures.efb0b9d1.svg";